<style lang="scss">
.text-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.text-input-preview-text {
  font-size: 1.4rem;
}
.ql-editor {
  font-size: 15px;
}
</style>
<template>
  <div class="text-input">
    <div class="text-input-form" v-if="isEditing">
      <div class="form-group">
        <quill-editor v-model="text"></quill-editor>
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="text-input-preview input-preview" v-else>
      <p
        class="text-input-preview-text"
        v-html="text.replace(/\n/g, '<br/>')"
      ></p>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';

export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          text: this.text,
        },
        action: 'text',
        id: this.id,
      };
    },
    valid() {
      return this.text.length;
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('テキストを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  mounted() {
    this.text = this.value.text;
  },
  components: {
    'footer-menu': footerMenu,
  },
  data() {
    return {
      isEditing: false,
      text: '',
    };
  },
};
</script>
